import React from "react";
import __ from "src/utils/Translations";
import { isNull, isEmpty } from "lodash";

const getBenefitPerson = ({ beneficiaryFirstName, beneficiaryLastName }) =>
  beneficiaryFirstName !== "-" && beneficiaryLastName !== "-"
    ? `${__("dla")} ${beneficiaryFirstName} ${beneficiaryLastName} ${
        isEmpty(beneficiaryFirstName) && isEmpty(beneficiaryLastName)
          ? "..."
          : ""
      }`
    : "";

const BenefitNameColumn = (cellInfo) => {
  const benefitName = cellInfo.row[cellInfo.column.id];
  const beneficiaryPerson = getBenefitPerson(cellInfo.original);

  return (
    <span className="text-break text-center">
      <strong>{benefitName} </strong>
      {beneficiaryPerson}
    </span>
  );
};

export default BenefitNameColumn;
